/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TripListRefetchQueryVariables = {
    after?: string | null;
    aroundTripUUID?: string | null;
    before?: string | null;
    first?: number | null;
    last?: number | null;
    id: string;
};
export type TripListRefetchQueryResponse = {
    readonly node: {
        readonly " $fragmentRefs": FragmentRefs<"TripList_appuser">;
    } | null;
};
export type TripListRefetchQuery = {
    readonly response: TripListRefetchQueryResponse;
    readonly variables: TripListRefetchQueryVariables;
};



/*
query TripListRefetchQuery(
  $after: String
  $aroundTripUUID: String
  $before: String
  $first: Int
  $last: Int
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...TripList_appuser_Tbs2m
    id
  }
}

fragment PredictionAggregatorsList_predictionAggregators on PredictionAggregator {
  predictions {
    startDate
    activityPredictionModelIdentifier
    predictedActivities {
      activityType
      confidence
    }
  }
  aggregatePredictedActivity {
    activityType
    confidence
  }
}

fragment TripList_appuser_Tbs2m on AppUserNode {
  id
  apptrips(first: $first, after: $after, last: $last, before: $before, aroundTripUUID: $aroundTripUUID) {
    edges {
      node {
        id
        uuid
        ...TripList_trip
        ...TripViewer_trip
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}

fragment TripList_trip on TripNode {
  id
  uuid
  utcoffset
  isDeleted
  isExcluded
  excludedReason
  created
  modified
  localStartDate
  localEndDate
  computedLengthMeters
  computedActivityType
  enteredActivityType
  computedMapBounds
  routeData {
    routeIds
    earliestFirstSeen
    latestFirstSeen
  }
  client {
    platform
    deviceModel
    userAgent
    version
    build
  }
}

fragment TripViewer_trip on TripNode {
  id
  uuid
  utcoffset
  isDeleted
  isExcluded
  excludedReason
  created
  modified
  localStartDate
  localEndDate
  computedLengthMeters
  computedActivityType
  enteredActivityType
  computedMapBounds
  computedStartLocationDescription
  computedEndLocationDescription
  routeData {
    preparedLocations
    rawLocations
  }
  routes {
    creationDate
    closedDate
    tossed
    tossedDate
    tossedReason
    summaryLocations
    deleted
    activityType
    originalLengthMeters
    predictionAggregators {
      aggregatePredictedActivity {
        confidence
        activityType
      }
      predictions {
        startDate
      }
      ...PredictionAggregatorsList_predictionAggregators
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aroundTripUUID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "aroundTripUUID",
    "variableName": "aroundTripUUID"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activityType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TripListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "TripList_appuser"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "TripListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "AUAppTripConnection",
                "kind": "LinkedField",
                "name": "apptrips",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TripNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TripNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uuid",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "utcoffset",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isExcluded",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "excludedReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "created",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "modified",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "localStartDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "localEndDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedLengthMeters",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedActivityType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enteredActivityType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedMapBounds",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RouteDataObject",
                            "kind": "LinkedField",
                            "name": "routeData",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "routeIds",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "earliestFirstSeen",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestFirstSeen",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "preparedLocations",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rawLocations",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientObject",
                            "kind": "LinkedField",
                            "name": "client",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "platform",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "deviceModel",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "userAgent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "version",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "build",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedStartLocationDescription",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "computedEndLocationDescription",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RouteNode",
                            "kind": "LinkedField",
                            "name": "routes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "creationDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "closedDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tossed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tossedDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tossedReason",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "summaryLocations",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "deleted",
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "originalLengthMeters",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PredictionAggregator",
                                "kind": "LinkedField",
                                "name": "predictionAggregators",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PredictedActivity",
                                    "kind": "LinkedField",
                                    "name": "aggregatePredictedActivity",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Prediction",
                                    "kind": "LinkedField",
                                    "name": "predictions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "activityPredictionModelIdentifier",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PredictedActivity",
                                        "kind": "LinkedField",
                                        "name": "predictedActivities",
                                        "plural": true,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": [
                  "aroundTripUUID"
                ],
                "handle": "connection",
                "key": "TripList_apptrips",
                "kind": "LinkedHandle",
                "name": "apptrips"
              }
            ],
            "type": "AppUserNode",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b615d7f90ce35087b2f2e13766b507d9",
    "id": null,
    "metadata": {},
    "name": "TripListRefetchQuery",
    "operationKind": "query",
    "text": "query TripListRefetchQuery(\n  $after: String\n  $aroundTripUUID: String\n  $before: String\n  $first: Int\n  $last: Int\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...TripList_appuser_Tbs2m\n    id\n  }\n}\n\nfragment PredictionAggregatorsList_predictionAggregators on PredictionAggregator {\n  predictions {\n    startDate\n    activityPredictionModelIdentifier\n    predictedActivities {\n      activityType\n      confidence\n    }\n  }\n  aggregatePredictedActivity {\n    activityType\n    confidence\n  }\n}\n\nfragment TripList_appuser_Tbs2m on AppUserNode {\n  id\n  apptrips(first: $first, after: $after, last: $last, before: $before, aroundTripUUID: $aroundTripUUID) {\n    edges {\n      node {\n        id\n        uuid\n        ...TripList_trip\n        ...TripViewer_trip\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n\nfragment TripList_trip on TripNode {\n  id\n  uuid\n  utcoffset\n  isDeleted\n  isExcluded\n  excludedReason\n  created\n  modified\n  localStartDate\n  localEndDate\n  computedLengthMeters\n  computedActivityType\n  enteredActivityType\n  computedMapBounds\n  routeData {\n    routeIds\n    earliestFirstSeen\n    latestFirstSeen\n  }\n  client {\n    platform\n    deviceModel\n    userAgent\n    version\n    build\n  }\n}\n\nfragment TripViewer_trip on TripNode {\n  id\n  uuid\n  utcoffset\n  isDeleted\n  isExcluded\n  excludedReason\n  created\n  modified\n  localStartDate\n  localEndDate\n  computedLengthMeters\n  computedActivityType\n  enteredActivityType\n  computedMapBounds\n  computedStartLocationDescription\n  computedEndLocationDescription\n  routeData {\n    preparedLocations\n    rawLocations\n  }\n  routes {\n    creationDate\n    closedDate\n    tossed\n    tossedDate\n    tossedReason\n    summaryLocations\n    deleted\n    activityType\n    originalLengthMeters\n    predictionAggregators {\n      aggregatePredictedActivity {\n        confidence\n        activityType\n      }\n      predictions {\n        startDate\n      }\n      ...PredictionAggregatorsList_predictionAggregators\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'edccfce4b1bb888240396ca4668a58e2';
export default node;
